import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    /*meta:{
      requiresAuth: true
    }*/
  },
 
  {
    path: '/torneos',
    name: 'torneos',
    component: () => import('../views/Torneos.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/add',
    name: 'add',
    component: () => import('../views/AddView.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/torneos/:id',
    name: 'torneos_edit',
    component: () => import('../views/EditView.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/juegos',
    name: 'juegos',
    component: () => import('../views/Juegos.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/game_log',
    name: 'game_log',
    component: () => import('../views/GameLog.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/jugadores',
    name: 'jugadores',
    component: () => import('../views/Jugadores.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/jugadores_acumulado',
    name: 'jugadores_acumulado',
    component: () => import('../views/JugadoresAcumulado.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/filtro',
    name: 'filtro',
    component: () => import('../views/Filtro.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/lideres',
    name: 'lideres',
    component: () => import('../views/Lideres.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/records_individuales',
    name: 'lideres_juego',
    component: () => import('../views/LideresIndividual.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/records_equipo',
    name: 'team_records',
    component: () => import('../views/TeamRecords.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/rivales',
    name: 'rivales',
    component: () => import('../views/Rivales.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/coachs',
    name: 'coachs',
    component: () => import('../views/Coachs.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/jugador/:id',
    name: 'jugador',
    component: () => import('../views/Jugador.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
  {
    path: '/jugadores_ncaa',
    name: 'jugadores_ncaa',
    component: () => import('../views/Jugadoresncaa.vue'),
    /*meta:{
      requiresAuth: true
    }*/
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  // Requires auth & no user
  if (requiresAuth && !(await store.dispatch("users/getCurrentUser"))) {
    next({ name: "auth" });
    // No requires auth and user (auth)
  } else if (!requiresAuth && (await store.dispatch("users/getCurrentUser"))) {
    next({ name: "Home" });
  } else {
    // Anything else
    next();
  }
});
